import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import Tab from '../../../components/Tab';
import Menu from '../../../components/Menu';
import HasRole from '../../../components/HasRole';
import Loading from '../Loading';

import * as constants from '../../Authorization/constants';
import '../styles.css';

import messages from './messages';
import menuItems from './menu';
import { withEnabledFeatures } from '../../../utils/features';
import { CAMINO_MENU_TYPE, DEFAULT_CONTENT_TYPE, CAMINO_CONTENT_TYPE } from '../constants';

export function handleOnClick(menuOption, setVisibleField, onSelectItem) {
  if (menuOption.render) {
    setVisibleField(menuOption.type);
  } else {
    onSelectItem({
      menuType: menuOption.type,
      contentType: menuOption.type === CAMINO_MENU_TYPE ? CAMINO_CONTENT_TYPE : DEFAULT_CONTENT_TYPE,
    });
  }
}

export function filterMenuItems(enabledFeatures, items) {
  if (!enabledFeatures) return [];
  return enabledFeatures.includes('CAMINO_HEM_TRANSFERINFO') ? items : items.filter((item) => item.type !== 'transferInfo');
}

export const BasicInfoMenuComponent = ({ isLoaded, onSelectItem, menuType, intl, enabledFeatures = undefined }) => {
  const [visibleField, setVisibleField] = useState(null);
  const menuOptions = useMemo(() => {
    const filteredMenuItems = filterMenuItems(enabledFeatures, menuItems);
    if (!isLoaded || !filteredMenuItems.length) return [];
    if (menuType) return filteredMenuItems.find((item) => item.type === menuType).items;
    return filteredMenuItems;
  }, [isLoaded, menuType, enabledFeatures]);

  if (isLoaded) {
    return (
      <Tab.Pane attached={false}>
        <Menu vertical styleName="editor-menu">
          <HasRole anyOf={[constants.ADMIN_ROLE, constants.PUBLISHING_ROLE]}>
            {menuOptions.map((menuOption) => {
              const Component = visibleField === menuOption.type ? menuOption.render : null;
              const message = {
                id: `premium-menu.basic-info.menu-item-${menuOption.type}`,
                ...messages[menuOption.type],
              };
              return (
                <Menu.Item
                  as="li"
                  key={menuOption.type}
                  styleName={`editor-menu-item ${visibleField === menuOption.type ? '' : 'enabled'}`}
                  data-cy={`Premium-Hem-Menu-Item-${menuOption.type}`}
                  link
                  onClick={() => {
                    handleOnClick(menuOption, setVisibleField, onSelectItem);
                  }}
                >
                  <FormattedMessage {...message} />
                  {Component && <Component formatMessage={intl.formatMessage} />}
                </Menu.Item>
              );
            })}
          </HasRole>
        </Menu>
      </Tab.Pane>
    );
  }

  return (
    <Loading />
  );
};

BasicInfoMenuComponent.propTypes = {
  isLoaded: PropTypes.bool,
  onSelectItem: PropTypes.func,
  menuType: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  enabledFeatures: PropTypes.array,
};

const BasicInfoMenu = withEnabledFeatures(injectIntl(BasicInfoMenuComponent));
export default BasicInfoMenu;
